module.exports = "../content/876701bc4fbf6166f07f152691b15159.ttf";